'use client';
import RPCUrls from '@/third-party/RPCUrls';
import { createConfig, http, createStorage, noopStorage } from 'wagmi';
import { bsc, bscTestnet, mainnet, sepolia } from 'wagmi/chains';
import { getDefaultConfig } from 'connectkit';
import { injected, walletConnect } from 'wagmi/connectors';

const getAppUrl = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || 'https://0xarbitrage.org';
  return siteUrl.startsWith('http') ? siteUrl : `https://${siteUrl}`;
};

const walletConnectProjectId =
  process.env.NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID || '';

const connectKitOptions = getDefaultConfig({
  chains: [mainnet, sepolia, bsc, bscTestnet],
  transports: {
    [mainnet.id]: http(RPCUrls.ethMainNet),
    [bsc.id]: http(RPCUrls.bnbMainNet),
    [sepolia.id]: http(RPCUrls.ethSepolia),
    [bscTestnet.id]: http(RPCUrls.bnbTestNet),
  },
  walletConnectProjectId,
  appName: '0xarbitrage',
  appDescription: 'The New Standard for Gold-Backed DeFi Tools',
  appUrl: getAppUrl(),
  appIcon: `${getAppUrl()}/favicons/android-icon-192x192.png`,
  enableAaveAccount: false,
});

const safepalIcon =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'><rect width='128' height='128' rx='28' fill='%230c1022'/><path d='M78.6 34.5H49.4C41.2 34.5 34.5 41.2 34.5 49.4V62.8C34.5 71 41.2 77.7 49.4 77.7H66.2V65.4H49.4C48 65.4 46.8 64.2 46.8 62.8V49.4C46.8 48 48 46.8 49.4 46.8H78.6C80 46.8 81.2 48 81.2 49.4V62.8C81.2 64.2 80 65.4 78.6 65.4H74.2V77.7H78.6C86.8 77.7 93.5 71 93.5 62.8V49.4C93.5 41.2 86.8 34.5 78.6 34.5Z' fill='%233375FD'/><path d='M49.4 93.5H78.6C86.8 93.5 93.5 86.8 93.5 78.6V77.7H81.2V78.6C81.2 80 80 81.2 78.6 81.2H49.4C48 81.2 46.8 80 46.8 78.6V77.7H34.5V78.6C34.5 86.8 41.2 93.5 49.4 93.5Z' fill='%233375FD'/></svg>";

export const config = createConfig({
  ...connectKitOptions,
  connectors: [
    injected({ target: 'metaMask' }),
    injected({
      target: {
        id: 'com.trustwallet.app',
        name: 'Trust Wallet',
        provider(window) {
          if (typeof window === 'undefined') return undefined;
          return (
            (window as any)?.trustwallet?.ethereum ||
            ((window as any)?.ethereum?.isTrust
              ? (window as any).ethereum
              : undefined)
          );
        },
      },
    }),
    injected({
      target: {
        id: 'safepal',
        name: 'SafePal',
        icon: safepalIcon,
        provider(window) {
          if (typeof window === 'undefined') return undefined;
          return (
            (window as any)?.safepalProvider ||
            (window as any)?.safepal?.ethereum ||
            ((window as any)?.ethereum?.isSafePal
              ? (window as any).ethereum
              : undefined)
          );
        },
      },
    }),
    walletConnect({
      projectId: walletConnectProjectId,
      showQrModal: false,
      metadata: {
        name: '0xarbitrage',
        description: 'The New Standard for Gold-Backed DeFi Tools',
        url: getAppUrl(),
        icons: [`${getAppUrl()}/favicons/android-icon-192x192.png`],
      },
    }),
  ],
  storage: createStorage({
    storage: typeof window !== 'undefined' ? window.localStorage : noopStorage,
  }),
});

export { config as WagmiConfig };
